import styled from "@emotion/styled";

export const Container = styled.div`
  display: grid;
  place-items: center;
  height: 500px;
  max-height: 50vh;
  border: ${({ theme }) => theme.palette.divider};
`;
